import {
  CellContentTypes,
  TextAlignTypes,
} from "../../../../assets/globalConstants";

export const optionsFilter = [
  { text: "badgesList.campaign", value: "campaign" },
  { text: "badgesList.recipient", value: "email" },
];

export const headersBadgesListTable = [
  {
    key: "id",
    text: "badgesList.id",
    tag: true,
    type: CellContentTypes.tag,
    short: true,
  },
  {
    key: "campaignName",
    text: "badgesList.campaignName",
    tag: true,
    type: CellContentTypes.tag,
    short: true,
  },
  {
    key: "createdAt",
    text: "badgesList.creationDate",
    textAlign: TextAlignTypes.center,
    type: CellContentTypes.date,
  },
  {
    key: "recipient",
    text: "badgesList.recipient",
    textAlign: TextAlignTypes.center,
    type: CellContentTypes.action,
  },
  {
    key: "status",
    text: "badgesList.status",
    textAlign: TextAlignTypes.center,
    type: CellContentTypes.tag,
  },
  {
    key: "actions",
    text: "badgesList.actions",
    textAlign: TextAlignTypes.right,
    type: CellContentTypes.action,
  },
];
